import React, { lazy } from 'react'

const TrustCenterPage = lazy(() => import('./TrustCenterPage'))

export { TrustCenterPage }
